import React from 'react';
import { Instagram, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { restaurantInfo } from '../data/mock';

const SocialSection = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-amber-700 to-amber-800 relative overflow-hidden" aria-labelledby="social-heading">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Header */}
          <h2 id="social-heading" className="font-serif text-4xl md:text-5xl font-bold text-white mb-4">
            Redes Sociais
          </h2>
          <p className="text-white/80 text-xl mb-10">
            Acompanhe o Japamix, restaurante japonês em Anápolis, no Instagram.
          </p>

          {/* Social Button */}
          <div className="flex items-center justify-center">
            <Button
              size="lg"
              className="bg-white hover:bg-neutral-100 text-neutral-900 font-semibold px-8 py-6 text-lg btn-hover-lift flex items-center gap-3"
              onClick={() => window.open(restaurantInfo.social.instagram, '_blank')}
              aria-label="Seguir Japamix no Instagram"
            >
              <Instagram size={24} aria-hidden="true" />
              Siga no Instagram
              <ArrowRight size={18} aria-hidden="true" />
            </Button>
          </div>

          {/* Instagram handle */}
          <div className="mt-8">
            <p className="text-white/70">
              <span className="font-semibold text-white">@japamiix</span> • Siga-nos para novidades
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialSection;
